import { render, staticRenderFns } from "./emptyTip.vue?vue&type=template&id=3ad891d7&scoped=true"
import script from "./emptyTip.vue?vue&type=script&lang=js"
export * from "./emptyTip.vue?vue&type=script&lang=js"
import style0 from "./emptyTip.vue?vue&type=style&index=0&id=3ad891d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad891d7",
  null
  
)

export default component.exports